<template>
  <div>
    <v-radio-group v-model="viewMode" row class="mt-2 ml-4 pa-0" hide-details>
      <v-radio label="Jewish" value="jewish" color="success"></v-radio>
      <v-radio label="Gregorian" value="gregorian" color="success"></v-radio>
    </v-radio-group>
    <div
      class="mx-4 mt-1"
      style="display: flex; align-items: center; position: relative;"
    >
      <v-layout row justify-space-between>
        <v-btn
          style="background-color: #fff !important;"
          color="success"
          outline
          title="Export"
          @click="exportDialog = true"
        >
          Export
        </v-btn>
        <v-layout
          row
          justify-center
          style="position: absolute; left: 50%; transform: translateX(-50%);"
        >
          <v-btn
            style="background-color: #fff !important;"
            color="success"
            outline
            @click="prevMonth()"
            title="Previous Month"
          >
            <v-icon left>mdi-chevron-left</v-icon>
            Prev
          </v-btn>
          <div class="px-3 mt-3" style="text-align: center;">
            <div v-if="viewMode === 'jewish'">
              <div class="headline">
                {{ currentHebrewMonthLabel }}
              </div>
              <div>
                {{ currentGregorianMonthLabel }}
              </div>
            </div>
            <div v-else>
              <div class="headline">
                {{ currentGregorianMonthLabel }}
              </div>
              <div>
                {{ currentHebrewMonthLabel }}
              </div>
            </div>
          </div>
          <v-btn
            style="background-color: #fff !important;"
            color="success"
            outline
            @click="nextMonth()"
            title="Next Month"
          >
            Next
            <v-icon dark>mdi-chevron-right</v-icon>
          </v-btn>
        </v-layout>
        <v-btn
          style="background-color: #fff !important;"
          color="success"
          outline
          @click="goToDateDialog = true"
          title="Quick Jump to Date"
        >
          Go to Date
        </v-btn>
      </v-layout>
    </div>
    <v-flex xs12 class="mx-4 mt-2">
      <v-sheet width="100%" style="position: relative;">
        <div v-if="loading" class="calendar-loading-overlay">
          <v-progress-circular
            indeterminate
            color="success"
            size="60"
          ></v-progress-circular>
        </div>
        <v-calendar
          @change="loadDayData"
          style="border: 2px solid #5cb860;"
          color="primary"
          ref="calendar"
          type="custom-weekly"
          :start="calendarStart"
          :end="calendarEnd"
        >
          <template v-slot:day="{ date }">
            <template v-if="dayDataMap[date]">
              <div
                class="day-bg"
                :style="{ backgroundColor: dayDataMap[date].bgColor }"
              ></div>
              <div v-if="viewMode === 'jewish'">
                <div style="direction: rtl;" class="day-label-1">
                  {{ dayDataMap[date].hebrewDay }}
                </div>
                <div class="day-label-2">
                  {{ dayDataMap[date].gregorianLabel }}
                </div>
              </div>
              <div v-else>
                <div class="day-label-1">
                  {{ dayDataMap[date].gregorianLabel.split(" ")[1] }}
                </div>
                <div style="direction: rtl;" class="day-label-2">
                  {{ dayDataMap[date].hebrewDay }}
                  {{ dayDataMap[date].hebrewMonth }}
                </div>
              </div>
              <div class="day-label-holiday">
                {{ dayDataMap[date].holiday }}
              </div>
              <div class="day-label-zmanim">
                {{ dayDataMap[date].zmanim }}
              </div>
            </template>
          </template>
        </v-calendar>
      </v-sheet>
    </v-flex>
    <calendar-export-dialog
      v-model="exportDialog"
      :default-start-date="calendarStartDate"
      :default-end-date="calendarEndDate"
      @export="handleCalendarExport"
    />
    <v-dialog
      v-model="goToDateDialog"
      max-width="500"
      content-class="dialog-top"
    >
      <v-card>
        <v-card-title
          style="background-color: #5cb860; color: white;"
          class="headline"
          >Go to Date</v-card-title
        >
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                v-model="goToDate.gregorianMonth"
                :items="gregorianMonths"
                label="Month"
              ></v-select>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <v-text-field
                v-model="goToDate.gregorianYear"
                label="Year"
                :rules="[
                  (value) => {
                    if (isNaN(value) || value < 1000)
                      return 'Enter 4 digit year';
                    return true;
                  },
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-btn
                :disabled="
                  !goToDate.gregorianMonth ||
                    !goToDate.gregorianYear ||
                    isNaN(goToDate.gregorianYear)
                "
                flat
                color="success"
                @click="goToGregorianMonth()"
                >{{
                  "Go To - " +
                    goToDate.gregorianMonth +
                    " " +
                    goToDate.gregorianYear
                }}</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <v-select
                v-model="goToDate.hebrewMonth"
                :items="hebrewMonths"
                label="חודש"
                style="direction: rtl;"
              >
                <template slot="item" slot-scope="{ item }">
                  <span style="direction: rtl;">{{ item }}</span>
                </template>
              </v-select>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <v-text-field
                v-model="goToDate.hebrewYear"
                label="שנת"
                :rules="[
                  (v) =>
                    !v ||
                    /^[\u05D0-\u05EA]$|^[\u05D0-\u05EA]{1,4}[\u0022\u05F4]?[\u05D0-\u05EA]$/.test(
                      v
                    ) ||
                    'Enter a valid Jewish year',
                ]"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-btn
                :disabled="!goToDate.hebrewMonth || !goToDate.hebrewYear"
                flat
                color="success"
                @click="goToHebrewMonth()"
                >{{
                  "Go To - " + goToDate.hebrewMonth + " " + goToDate.hebrewYear
                }}</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn
            outline
            @click="goToCurrentMonth()"
            title="Go to Current Month"
            small
          >
            Current Month
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="default" small dark @click="goToDateDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  HDate,
  HebrewCalendar,
  getSedra,
  Locale,
  gematriya,
  gematriyaStrToNum,
  GeoLocation,
  Zmanim,
} from "@hebcal/core";
import moment from "moment";
import CalendarExportDialog from "./CalendarExportDialog.vue";
import { exportCalendarToExcel, exportCalendarToPdf } from "./calendarExport";

export default {
  components: {
    CalendarExportDialog,
  },
  data: () => ({
    title: "Calendar",
    viewMode: "jewish",
    hebrewMonth: null,
    gregorianMonth: null,
    loading: false,
    dayDataMap: {},
    goToDateDialog: false,
    exportDialog: false,
    calendarStartDate: "",
    calendarEndDate: "",
    goToDate: {
      gregorianMonth: moment().month() + 1,
      gregorianYear: moment().year(),
      hebrewMonth: "",
      hebrewYear: "",
    },
    gregorianMonths: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    hebrewMonths: [
      "תשרי",
      "חשוון",
      "כסלו",
      "טבת",
      "שבט",
      "אדר",
      "אדר א׳",
      "אדר ב׳",
      "ניסן",
      "אייר",
      "סיוון",
      "תמוז",
      "אב",
      "אלול",
    ],
    currentGregorianMonthLabel: "",
    currentHebrewMonthLabel: "",
  }),
  metaInfo() {
    return {
      title: `${this.title}`,
    };
  },
  created() {
    const today = new HDate(new Date());
    this.hebrewMonth = { month: today.getMonth(), year: today.getFullYear() };
    this.gregorianMonth = {
      month: moment().month() + 1,
      year: moment().year(),
    };

    // this.gregorianPageStart = moment()
    //   .startOf("month")
    //   .format("YYYY-MM-DD");

    this.loadDayData();

    // Suppress Vue warnings
    this._prevWarnHandler = Vue.config.warnHandler;
    Vue.config.warnHandler = (msg, vm, trace) => {
      if (msg.includes(".native modifier")) return;
      (this._prevWarnHandler || console.warn.bind(console, "[Vue warn]:"))(
        msg,
        vm,
        trace
      );
    };
  },

  watch: {
    viewMode(newMode) {
      if (newMode === "gregorian" && this.hebrewMonthDays.length) {
        const date = moment(this.hebrewMonthDays[0].greg()).format(
          "YYYY-MM-DD"
        );
        this.gregorianMonth = {
          month: moment(date).month() + 1,
          year: moment(date).year(),
        };
      } else if (newMode === "jewish" && this.gregorianMonth) {
        const hd = new HDate(
          moment(
            `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
          ).toDate()
        );
        this.hebrewMonth = { month: hd.getMonth(), year: hd.getFullYear() };
      }
    },
  },
  computed: {
    hebrewMonthDays() {
      if (!this.hebrewMonth) return [];
      const firstDay = new HDate(
        1,
        this.hebrewMonth.month,
        this.hebrewMonth.year
      );
      return Array.from({ length: firstDay.daysInMonth() }, (_, i) => {
        return new HDate(i + 1, this.hebrewMonth.month, this.hebrewMonth.year);
      });
    },
    calendarStart() {
      if (this.viewMode === "jewish") {
        if (!this.hebrewMonthDays.length) return "";
        return this.toISODate(this.hebrewMonthDays[0].greg());
      } else {
        return `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`;
      }
    },
    calendarEnd() {
      if (this.viewMode === "jewish") {
        if (!this.hebrewMonthDays.length) return "";
        return this.toISODate(
          this.hebrewMonthDays[this.hebrewMonthDays.length - 1].greg()
        );
      } else {
        return `${this.gregorianMonth.year}-${
          this.gregorianMonth.month
        }-${moment(
          `${this.gregorianMonth.year}-${this.gregorianMonth.month}`,
          "YYYY-M"
        ).daysInMonth()}`;
      }
    },
  },
  methods: {
    setCurrentMonthLabel() {
      const hebrewStart = new HDate(
        new Date(`${this.calendarStartDate}T00:00:00`)
      );
      const hebrewStartMonth = this.formatHebrewMonthName(hebrewStart.greg());
      const hebrewStartYear = gematriya(hebrewStart.getFullYear(), 3);
      const hebrewEnd = new HDate(new Date(`${this.calendarEndDate}T00:00:00`));
      const hebrewEndMonth = this.formatHebrewMonthName(hebrewEnd.greg());
      const hebrewEndYear = gematriya(hebrewEnd.getFullYear(), 3);
      const gregorianMonthStart = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(new Date(`${this.calendarStartDate}T00:00:00`));
      const gregorianMonthEnd = new Intl.DateTimeFormat("en-US", {
        month: "long",
      }).format(new Date(`${this.calendarEndDate}T00:00:00`));

      const hebrewStartMounthAndYear = hebrewStartMonth + " " + hebrewStartYear;
      const hebrewEndMounthAndYear = hebrewEndMonth + " " + hebrewEndYear;

      this.currentHebrewMonthLabel =
        hebrewStartMounthAndYear == hebrewEndMounthAndYear
          ? hebrewStartMounthAndYear
          : hebrewStartYear == hebrewEndYear
          ? hebrewStartMonth + " - " + hebrewEndMounthAndYear
          : hebrewStartMounthAndYear + " - " + hebrewEndMounthAndYear;

      const gregorianStartYear = new Date(
        `${this.calendarStartDate}T00:00:00`
      ).getFullYear();
      const gregorianEndYear = new Date(
        `${this.calendarEndDate}T00:00:00`
      ).getFullYear();
      const gregorianStartMonthAndYear =
        gregorianMonthStart + " " + gregorianStartYear;
      const gregorianEndMonthAndYear =
        gregorianMonthEnd + " " + gregorianEndYear;

      this.currentGregorianMonthLabel =
        gregorianStartMonthAndYear === gregorianEndMonthAndYear
          ? gregorianStartMonthAndYear
          : gregorianStartYear === gregorianEndYear
          ? gregorianMonthStart + " - " + gregorianEndMonthAndYear
          : gregorianStartMonthAndYear + " - " + gregorianEndMonthAndYear;
      this.goToDate.gregorianMonth = gregorianMonthStart;
      this.goToDate.gregorianYear = gregorianStartYear;
      this.goToDate.hebrewMonth = hebrewStartMonth;
      this.goToDate.hebrewYear = hebrewStartYear;
    },

    async loadDayData() {
      this.dayDataMap = {};
      this.loading = true;
      await new Promise((resolve) => setTimeout(resolve, 0));
      this.dayDataMap = this.computeDayData();
      this.loading = false;
    },
    computeDayData() {
      const SHORT_MONTHS = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const ALLOWED_HOLIDAY_BASENAMES = new Set([
        "Rosh Hashana",
        "Yom Kippur",
        "Sukkot",
        "Shmini Atzeret",
        "Simchat Torah",
        "Chanukah",
        "Tu BiShvat",
        "Purim",
        "Pesach",
        "Lag BaOmer",
        "Shavuot",
        "Tzom Gedaliah",
        "Asara B'Tevet",
        "Ta'anit Esther",
        "Tzom Tammuz",
        "Tish'a B'Av",
      ]);

      const map = {};
      const days =
        this.viewMode === "jewish"
          ? this.hebrewMonthDays.map((hd) => ({ hd, greg: hd.greg() }))
          : (() => {
              const result = [];
              const start = moment(
                `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
              ).startOf("month");
              const end = moment(
                `${this.gregorianMonth.year}-${this.gregorianMonth.month}-01`
              ).endOf("month");
              for (
                let d = start.clone();
                d.isSameOrBefore(end, "day");
                d.add(1, "day")
              ) {
                const greg = d.toDate();
                result.push({ hd: new HDate(greg), greg });
              }
              return result;
            })();
      this.calendarStartDate = this.toISODate(days[0].greg);
      this.calendarEndDate = this.toISODate(days[days.length - 1].greg);
      this.setCurrentMonthLabel();
      const location = new GeoLocation(
        "New York",
        40.7128,
        -74.006,
        0,
        "America/New_York"
      );
      const timeFormat = new Intl.DateTimeFormat("en-US", {
        hour: "2-digit",
        minute: "2-digit",
      });

      for (const { hd, greg } of days) {
        const zmanim = new Zmanim(location, greg, false);
        const shkiah = this.formatTimeForRtl(
          Zmanim.formatTime(zmanim.shkiah(), timeFormat)
        );
        const rabbeinuTam = Zmanim.formatTime(
          zmanim.sunsetOffset(+72),
          timeFormat
        );
        const rabbeinuTamFormatted = this.formatTimeForRtl(rabbeinuTam);
        const candleLighting =
          greg.getDay() === 5
            ? this.formatTimeForRtl(
                Zmanim.formatTime(zmanim.sunsetOffset(-18), timeFormat)
              )
            : "";
        const holidays = (HebrewCalendar.getHolidaysOnDate(hd) || []).filter(
          (h) => {
            const base = h.basename();
            return ALLOWED_HOLIDAY_BASENAMES.has(base);
          }
        );
        const isYomHatzala =
          hd.getMonth() === HDate.monthNum("Kislev") && hd.getDate() === 21;
        const isSaturday = greg.getDay() === 6;
        const isToday =
          new Date().toLocaleDateString() == greg.toLocaleDateString();
        const sedraInfo = isSaturday ? getSedra(hd.getFullYear(), false).lookup(hd) : null;
        const parshaText =
          sedraInfo && Array.isArray(sedraInfo.parsha) && sedraInfo.parsha.length
            ? `פרשת ${sedraInfo.parsha
                .map((name) => Locale.gettext(name, "he"))
                .join(" - ")}`
            : "";
        const holidayText = isYomHatzala
          ? "כ״א כִּסְלֵו – יוֹם הַהַצָּלָה"
          : holidays.length > 0
          ? holidays[0].render("he")
          : "";

        map[this.toISODate(greg)] = {
          hebrewDay: gematriya(hd.getDate()),
          hebrewMonth: this.formatHebrewMonthName(greg),
          gregorianLabel: SHORT_MONTHS[greg.getMonth()] + " " + greg.getDate(),
          holiday:
            holidayText && parshaText
              ? `${holidayText} | ${parshaText}`
              : holidayText || parshaText,
          zmanim:
            greg.getDay() === 5
              ? `הדלקת הנרות: ${candleLighting}`
              : greg.getDay() === 6
              ? `מוצאי שבת: ${rabbeinuTamFormatted}`
              : "",
          bgColor: isToday
            ? "#e8f7fa"
            : isSaturday || holidays.length > 0 || isYomHatzala
            ? "#fff8e1"
            : "#ffffff",
        };
      }
      return map;
    },
    toISODate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    prevMonth() {
      let { month, year } = this.hebrewMonth;
      month--;
      if (month < 1) {
        month = HDate.monthsInYear(year);
      } else if (month === 6) {
        year--;
      }
      this.hebrewMonth = { month, year };
      const prevGreg = moment({
        year: this.gregorianMonth.year,
        month: this.gregorianMonth.month - 1,
      }).subtract(1, "month");
      this.gregorianMonth = {
        month: prevGreg.month() + 1,
        year: prevGreg.year(),
      };
    },

    nextMonth() {
      let { month, year } = this.hebrewMonth;
      const maxMonth = HDate.monthsInYear(year);
      month++;
      if (month > maxMonth) {
        month = 1;
      } else if (month === 7) {
        year++;
      }
      this.hebrewMonth = { month, year };
      const nextGreg = moment({
        year: this.gregorianMonth.year,
        month: this.gregorianMonth.month - 1,
      }).add(1, "month");
      this.gregorianMonth = {
        month: nextGreg.month() + 1,
        year: nextGreg.year(),
      };
    },

    goToHebrewMonth() {
      this.viewMode = "jewish";
      const hd = new HDate(
        1,
        this.goToDate.hebrewMonth,
        gematriyaStrToNum(this.goToDate.hebrewYear) + 5000
      );
      this.hebrewMonth = { month: hd.getMonth(), year: hd.getFullYear() };
      this.goToDateDialog = false;
    },

    goToGregorianMonth() {
      this.viewMode = "gregorian";
      const parsed = moment(
        `${this.goToDate.gregorianMonth} ${this.goToDate.gregorianYear}`,
        "MMMM YYYY"
      );
      if (!parsed.isValid()) return;
      this.gregorianMonth = { month: parsed.month() + 1, year: parsed.year() };
      this.goToDateDialog = false;
    },
    goToCurrentMonth() {
      const today = new HDate(new Date());
      this.hebrewMonth = { month: today.getMonth(), year: today.getFullYear() };
      this.gregorianMonth = {
        month: moment().month() + 1,
        year: moment().year(),
      };
      this.goToDateDialog = false;
    },
    formatHebrewMonthName(gregorianDate) {
      return new Intl.DateTimeFormat("he-u-ca-hebrew", {
        month: "long",
      }).format(gregorianDate);
    },
    formatTimeForRtl(timeText) {
      return `\u200E${timeText}\u200E`;
    },
    async handleCalendarExport({ format, startDate, endDate }) {
      const rows = this.getExportRows(startDate, endDate);
      if (format === "pdf") {
        await exportCalendarToPdf(rows, {
          startDate,
          endDate,
          titleText:
            this.viewMode === "jewish"
              ? `<h2>${this.currentHebrewMonthLabel}</h2> <br> ${
                  this.currentGregorianMonthLabel
                }`
              : `<h2>${this.currentGregorianMonthLabel}</h2> <br> ${
                  this.currentHebrewMonthLabel
                }`,
        });
      } else {
        exportCalendarToExcel(rows, { startDate, endDate });
      }
      this.exportDialog = false;
    },
    getExportRows(startDate, endDate) {
      const start = moment(startDate, "YYYY-MM-DD").startOf("day");
      const end = moment(endDate, "YYYY-MM-DD").startOf("day");
      const rows = [];

      for (
        let day = start.clone();
        day.isSameOrBefore(end, "day");
        day.add(1, "day")
      ) {
        const isoDate = day.format("YYYY-MM-DD");
        const dayData = this.dayDataMap[isoDate];
        if (!dayData) {
          continue;
        }
        rows.push({
          isoDate,
          gregorianDate: isoDate,
          gregorianDay: Number(dayData.gregorianLabel.split(" ")[1]),
          hebrewDate: `${dayData.hebrewDay} ${dayData.hebrewMonth}`,
          holiday: dayData.holiday || "",
          zmanim: dayData.zmanim || "",
        });
      }

      return rows;
    },
  },
};
</script>
<style>
.v-calendar-weekly__day {
  min-height: 170px;
  position: relative;
}
.day-bg {
  position: absolute;
  inset: 0;
}

.day-label-1 {
  font-size: 1.75em;
  position: absolute;
  top: 4px;
  right: 6px;
  color: #5cb860;
  font-weight: 600;
}
.day-label-2 {
  margin-top: 5px;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #888;
}
.calendar-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.day-label-holiday {
  margin-top: 25px;
  direction: rtl;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #f44336;
  font-weight: 600;
}
.day-label-zmanim {
  bottom: 4px;
  direction: rtl;
  position: absolute;
  right: 6px;
  font-size: 0.85em;
  color: #555;
}
</style>
